<template>
  <v-autocomplete
    v-model="model"
    :items="items"
    :item-value="itemValue"
    :item-title="itemTitle"
    multiple
    chips
    closable-chips
    return-object
  />
</template>

<script lang="ts" setup generic="T">
interface Props {
  items: T[]
  itemTitle: keyof T
  itemValue: keyof T
}

defineEmits<{
  update: []
}>()

const { items, itemTitle, itemValue } = defineProps<Props>()

const model = defineModel<T[]>()
</script>
